export default "__VITE_ASSET__FA8DWFzA__"